import { render, staticRenderFns } from "./TableBasicInstitutions.vue?vue&type=template&id=d45b6bce&"
import script from "./TableBasicInstitutions.vue?vue&type=script&lang=js&"
export * from "./TableBasicInstitutions.vue?vue&type=script&lang=js&"
import style0 from "./TableBasicInstitutions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports